import { useMutation } from '@northladder/services';
import { IApiError } from '@northladder/utilities';

import { ILoginUserData, IValidateSSOPayload } from '../types';
import { USER_ACCOUNTS_API } from '../userAccountsAPIClient';

/**
 * This is to track the type mutation keys in react query cache.
 */
const VALIDATE_SSO_MUT = 'validate-sso-mutation-key';

/**
 * This defines the interface for `useValidateSSOMutation` options.
 */
interface IUseValidateSSOptions {
  onErrorCallback: (error: IApiError, variables: IValidateSSOPayload) => void;
  onSuccessCallback: (loginData: ILoginUserData) => void;
}

/**
 * This performs a profile update request.
 */
export const useValidateSSOMutation = ({
  onSuccessCallback,
  onErrorCallback,
}: IUseValidateSSOptions) => {
  const { isPending, error, mutate } = useMutation({
    mutationKey: [VALIDATE_SSO_MUT],
    networkMode: 'always',
    mutationFn: USER_ACCOUNTS_API.validateSSOUser,
    onSuccess: onSuccessCallback,
    onError: onErrorCallback,
  });

  return {
    error,
    isPending,
    validateSSO: mutate,
  };
};
